import React from 'react';
import { Eye } from 'lucide-react';
import './EmendaCard.css';

export default function EmendaCard({ emenda, columns, onViewDetails }) {
  const cardFields = columns.slice(0, 7);

  const formatValue = (value, columnHeader) => {
    if (!value || value === '-') return '-';
    
    // Detectar se é uma coluna de valor monetário
    const isValueColumn = columnHeader.toLowerCase().includes('valor') || 
                         columnHeader.toLowerCase().includes('vlr');
    
    if (isValueColumn) {
      // Converter valor americano para número
      const numericValue = parseFloat(String(value).replace(/[R$\s,]/g, ''));
      
      if (!isNaN(numericValue)) {
        // Formatar em Real brasileiro
        return new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(numericValue);
      }
    }
    
    return value;
  };

  return (
    <div className="emenda-card">
      <div className="emenda-card__content">
        {cardFields.map((column, index) => (
          <div key={index} className="emenda-card__field">
            <span className="emenda-card__label">{column.header}</span>
            <span className="emenda-card__value">
              {formatValue(emenda[column.accessorKey], column.header)}
            </span>
          </div>
        ))}
      </div>

      <div className="emenda-card__actions">
        <button
          onClick={() => onViewDetails(emenda)}
          className="emenda-card__button"
          aria-label="Ver detalhes da emenda"
        >
          <Eye className="w-4 h-4" />
          Ver Detalhes
        </button>
      </div>
    </div>
  );
}
